/**
 * 快捷键store
 */
import { defineStore } from 'pinia'

import {
  getDetailFastSet,
  fastReplyAllList,
  IFastGroupRequestParam,
  Type,
  FastReplyResponse
} from '@/server/user_fast_request'
import { throttle } from 'lodash'
interface IHotKeyStoreParam {
  sendKey: string
  newLine: string
  endSession: string
  fastReplyList: FastReplyResponse[] | undefined
}
/**
 * 快捷键设置
 */
export const useHotKeyStore = defineStore('hotkey', {
  state: (): IHotKeyStoreParam => {
    return {
      sendKey: 'Enter',
      newLine: 'Ctrl+Enter',
      endSession: 'F2',
      fastReplyList: undefined
    }
  },
  actions: {
    /**
     * 获取快捷键详情
     */
    async getHotKeyDetail() {
      await getDetailFastSet().then((res) => {
        if (res && res.code == '0') {
          this.sendKey = res?.data?.sendMsg ?? 'Enter'
          this.newLine = res?.data?.dialogNewline ?? 'Ctrl+Enter'
          this.endSession = res?.data?.endSession ?? 'F2'
        }
      })
    },
    getFastReplyShortcutKeyList() {
      return (this.fastReplyList || []).filter((item) => item.shortcuts)
    },
    async queryFastReplyList(param: IFastGroupRequestParam = { type: Type.Employee }) {
      await fastReplyAllList(param).then((res) => {
        this.fastReplyList = res.data || []
      })
    },
    async loadOnce() {
      if (!this.fastReplyList || this.fastReplyList.length === 0) {
        throttle(async () => await this.queryFastReplyList(), 1000)
      } else {
        console.log('快捷回复列表已存在 不进行加载！！！')
      }
    },
    updateFastReply(fastReply: FastReplyResponse) {
      //
      if (this.fastReplyList && this.fastReplyList.length > 0) {
        //
        const activeIndex = this.fastReplyList.findIndex((item) => item.id === fastReply.id)
        if (activeIndex != -1) {
          this.fastReplyList[activeIndex] = fastReply
        } else {
          this.fastReplyList.push(fastReply)
        }
      } else {
        this.fastReplyList = [fastReply]
      }
    },
    delFastReply(fastReply: FastReplyResponse) {
      //
      console.log(this.fastReplyList)
      if (this.fastReplyList && this.fastReplyList.length > 0) {
        //
        this.fastReplyList=this.fastReplyList.filter(function (item) {
          return item.shortcuts !== fastReply.shortcuts;
      });
      } 
    },
    /**
     * 设置快捷键
     *
     * @param value
     */
    setHotKey(value: string) {
      if (!value) return
      this.sendKey = value
    }
  },
  persist: {
    storage: sessionStorage
  }
})
